<ng-container *transloco="let t">
  @if (!multiSelection()) {
    <ISelectMenu
      popoverWidth="350"
      [(searchQuery)]="searchQuery"
      [value]="selectedAccountGroup()"
      (valueChange)="selectAccountGroup($event)"
      data-testid="account-group-selector"
    >
      <ISelectTrigger>
        <ISelectValue>
          <div *iSelectValue="let value">
            <span class="text-gray-800">{{ value.name }}</span>
          </div>
        </ISelectValue>
      </ISelectTrigger>
      <ISelectContent>
        @for (
          categorizedAccountGroup of filteredCategorizedAccountGroups();
          track categorizedAccountGroup.organizationId
        ) {
          <div class="px-2 py-0.5">
            <span class="text-xs tracking-tight text-gray-500">{{ categorizedAccountGroup.organizationName }}</span>
          </div>
          @for (accountGroup of categorizedAccountGroup.accountGroups; track accountGroup.id) {
            <ISelectOption [value]="accountGroup" [attr.data-testid]="'account-group-' + accountGroup.name">
              <app-account-group-selector-option [accountGroup]="accountGroup" />
            </ISelectOption>
          }
        }
      </ISelectContent>
    </ISelectMenu>
  } @else {
    <IMultiSelectMenu
      popoverWidth="350"
      [(searchQuery)]="searchQuery"
      [value]="selectedAccountGroups()"
      (valueChange)="selectAccountGroups($event)"
      data-testid="account-group-selector"
      withSelectOnly
    >
      <ISelectTrigger>
        <ISelectValue>
          <div *iSelectValue="let value">
            <span class="text-gray-800">{{ selectedAccountGroupsLabel() }}</span>
          </div>
        </ISelectValue>
      </ISelectTrigger>
      <ISelectContent>
        @if (filteredCategorizedAccountGroups().length > 0) {
          <ISelectOption selectAllOption>
            {{ t("common.all_accounts") }}
          </ISelectOption>
          <IDropdownMenuSeparator />
        }
        @for (
          categorizedAccountGroup of filteredCategorizedAccountGroups();
          track categorizedAccountGroup.organizationId
        ) {
          <div
            class="cursor-pointer rounded-xl px-2 py-0.5 hover:bg-slate-100"
            (click)="selectOrganization(categorizedAccountGroup)"
          >
            <span class="text-xs tracking-tight text-gray-500">{{ categorizedAccountGroup.organizationName }}</span>
          </div>
          @for (accountGroup of categorizedAccountGroup.accountGroups; track accountGroup.id) {
            <ISelectOption [value]="accountGroup" [attr.data-testid]="'account-group-' + accountGroup.name">
              <app-account-group-selector-option [accountGroup]="accountGroup" />
            </ISelectOption>
          }
        }
      </ISelectContent>
    </IMultiSelectMenu>
  }
</ng-container>
